import { applyMiddleware, compose, createStore } from 'redux';

import reducer from '../reducer';

const applyDevtools = () =>
  process.env.NODE_ENV !== 'production' && window.devToolsExtension
    ? window.devToolsExtension()
    : f => f;

const createStoreWithMiddleware = middleware => {
  return compose(
    applyMiddleware(...middleware),
    applyDevtools()
  )(createStore);
};

export const createReduxStore = ({ initialState, middleware }) =>
  createStoreWithMiddleware(middleware)(reducer, initialState);
